import type { UserProperties } from 'redux/modules/user.types';

export interface Avatar {
  large_retina: string;
  medium_retina: string;
}

export enum UserTimeFormat {
  H12 = 12,
  H24 = 24,
}

export interface LightUser {
  id: number;
  email: string;
  name: string;
  active: boolean;
  avatar: Avatar;
  updated_at: number;
  external_id: string;
  default_hour_rate: number;
  internal_hour_rate: number;
}

export interface User extends LightUser {
  id: number;
  day_view_onboarded: boolean;
  // Membership state for the current workspace, supplied by Rails and cleared by
  // PUT identity.json when onboarding_account_id identifies the completed workspace.
  workspace_onboarding_required?: boolean;
  memory_onboarded: boolean;
  created_at: number;
  last_received_memories_date: string | null;
  role_id: number;
  admin: boolean;
  can_create_projects?: boolean;
  hide_hourly_rate: boolean;
  hide_internal_hourly_rate: boolean;
  sign_in_count: number;
  time_zone: string;
  owner: boolean;
  time_format: UserTimeFormat;
  date_format: 'dmy' | 'mdy';
  properties: UserProperties;
  deleted: boolean;
  weekly_capacity: number;
  /** Comma separated days of week this user works */
  work_days: string;
  /** Available when fetching by ID, needed for user editor */
  active_projects_count?: number;
  /** The lowest memory retention period that has been acknowledged by the user */
  memory_retention_days: number | null;
}

export interface EnrichedUser extends User {
  role_name: string;
}
